export const ERRORCODE = {
  ACCINFOERR001: 'Invalid Account Number',
  required: ' Field is Required',
  min: 'Invalid',
  max: 'Invalid',
  minLength: 'Invalid',
  maxLength: 'Invalid',
};
